import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSub = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_115_2952)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5 21.3658C16.0228 21.3658 20.5 16.8887 20.5 11.3658C20.5 5.843 16.0228 1.36584 10.5 1.36584C4.97715 1.36584 0.5 5.843 0.5 11.3658C0.5 16.8887 4.97715 21.3658 10.5 21.3658Z",
				fill: "#001E50",
				stroke: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.14427 8.45168C9.76443 9.0845 9.3161 10.1516 8.43005 10.1516H3.81016V10.1516C3.28898 10.1516 3.02527 9.52393 3.39005 9.1517L5.89594 6.59464C6.28804 6.19454 6.93228 6.19454 7.32437 6.59464L9.14427 8.45168Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6762 14.28C11.056 13.6472 11.5044 12.5801 12.3904 12.5801H17.0103V12.5801C17.5314 12.5801 17.7951 13.2077 17.4304 13.58L14.9245 16.137C14.5324 16.5371 13.8881 16.5371 13.496 16.137L11.6762 14.28Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_115_2952",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 21,
			height: 22,
			fill: "white"
		})
	}) })]
});
export default SvgSub;
